import axios from 'axios';
import qs from 'query-string';
import { toastr } from 'react-redux-toastr'

const ResponseStatusCodes = {
    Unauthorized: 401,
    Forbidden: 403
};

const BASE_URL = '/api';

function CheckAuthenticationAndAuthorizationErrors(responseStatus, requestUrl) { 
    if (responseStatus === ResponseStatusCodes.Unauthorized && window.location.pathname !== "/login" && requestUrl !== "/account/myprofile") {
        window.location.replace("/login");
    } else if (responseStatus === Response.Forbidden) {
        toastr.error("You do not have permission to perform this action.");
    }
}

function getRequestHeaders(headers) {
    return {
        RequestVerificationToken: localStorage.getItem('RequestVerificationToken'),
        'Content-Type': 'application/json',
        ...headers
    };
}

export async function getRequest(requestUrl, params = null, dataType = {}, options = {}) {
    let result = { success: true, data: dataType, loading: false };

    try {
        let response = await axios.get(`${BASE_URL}${requestUrl}`, { params, paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }), ...options });
        result.status = response.status;
        if (response.status === 204) {
            result.success = false;
            result.noData = true;
        } else {
            result.data = (response.data !== null && response.data !== undefined)
                ? response.data
                : dataType;
        }
    } catch (error) {
        result.success = false;

        if (error.response) {
            if (error.response.data && error.response.data.message) result.message = error.response.data.message;
            CheckAuthenticationAndAuthorizationErrors(error.response.status, requestUrl);
        }
    }

    return result;
}

export async function postRequest(requestUrl, body = null, headers = {}, dataType = {}) {
    let result = { success: true, data: dataType, loading: false };

    try {
        let response = await axios.post(`${BASE_URL}${requestUrl}`, body, { headers: getRequestHeaders(headers) });
        result.data = response.data;
    } catch (error) {
        result.success = false;
        
        if (error.response) {
            if (error.response.data && error.response.data.message) {
                result.message = error.response.data.message;
                result.data = error.response.data.data || {};
            }
            CheckAuthenticationAndAuthorizationErrors(error.response.status, requestUrl);
        }
    }

    return result;
}

export async function putRequest(requestUrl, body = null, headers = {}, dataType = {}) {
    let result = { success: true, data: dataType, loading: false };

    try {
        // For FormData, don't set Content-Type header - let axios set it with boundary
        const requestHeaders = body instanceof FormData 
            ? { ...getRequestHeaders({}), ...headers }
            : getRequestHeaders(headers);
        // Remove Content-Type if it's FormData so axios can set it with boundary
        if (body instanceof FormData && requestHeaders['Content-Type']) {
            delete requestHeaders['Content-Type'];
        }
        let response = await axios.put(`${BASE_URL}${requestUrl}`, body, { headers: requestHeaders });
        result.data = response.data;
    } catch (error) {
        result.success = false;

        if (error.response) {
            if (error.response.data && error.response.data.message) {
                result.message = error.response.data.message;
                result.data = error.response.data.data || {};
            }
            CheckAuthenticationAndAuthorizationErrors(error.response.status, requestUrl);
        }
    }

    return result;
}

export async function patchRequest(requestUrl, update, headers = {}, dataType = {}) {
    let result = { success: true, data: dataType, loading: false }; 

    try {
        let patchDoc = [];
        for(var key in update) {
            patchDoc.push({op: 'replace', path: key, value: update[key]});
        }
        
        let response = await axios.patch(`${BASE_URL}${requestUrl}`, patchDoc, { headers: getRequestHeaders() });
        result.data = response.data;
    } catch (error) {
        result.success = false;

        if (error.response) {
            if (error.response.data && error.response.data.message) result.message = error.response.data.message;
            CheckAuthenticationAndAuthorizationErrors(error.response.status, requestUrl);
        }
    }

    return result;
}

export async function deleteRequest(requestUrl, params = null, dataType = {}) {
    let result = { success: true, loading: false, data: dataType };
    try {
        let response = await axios.delete(`${BASE_URL}${requestUrl}`, { params, paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }), headers: getRequestHeaders() });
        result.data = (response.data !== null && response.data !== undefined)
            ? response.data
            : dataType;
    } catch (error) {
        result.success = false;

        if (error.response) {
            if (error.response.data && error.response.data.message) result.message = error.response.data.message;
            CheckAuthenticationAndAuthorizationErrors(error.response.status, requestUrl);
        }
    }

    return result;
}


// WEBPACK FOOTER //
// ./src/lib/apiUtils.js